// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
import { ToolView } from './ToolView';
import { TerceraChartUtils } from '../TerceraChartUtils';
import { BarIndex } from '@shared/commons/cache/History/HistoryConstants';
export class RegressionChannelToolView extends ToolView {
    CalculateCoefficients(ww, param) {
        const tool = this.dataCacheTool;
        if (!tool)
            return;
        tool.needRecalculate = false;
        tool.coef = null;
        const minTime = Math.min(tool.Points[0][0], tool.Points[1][0]);
        const maxTime = Math.max(tool.Points[0][0], tool.Points[1][0]);
        const indexBegin = Math.ceil(ww.PointsConverter.GetBarIndex(minTime));
        const indexEnd = Math.floor(ww.PointsConverter.GetBarIndex(maxTime));
        const data = [];
        const mainCashItemSeries = param.mainPriceRenderer.Series;
        let pointIndex = 0;
        for (let i = indexBegin; i <= indexEnd; i++) {
            const realCashItemIndex = mainCashItemSeries.GetIndex(i);
            if (realCashItemIndex >= 0) {
                const tmp = new Array(3);
                tmp[0] = pointIndex + 1;
                tmp[1] = mainCashItemSeries.settings.RevertConverter(mainCashItemSeries.GetValue(i, tool.PriceTypeInt));
                tmp[2] = mainCashItemSeries.GetValue(i, BarIndex.Time);
                data.push(tmp);
                pointIndex++;
            }
        }
        tool.coef = TerceraChartUtils.calculateLinearRegression(data);
        if (tool.coef) {
            const x1 = tool.Points[0][0] < tool.Points[1][0] ? data[0][0] : data[data.length - 1][0];
            const x2 = tool.Points[0][0] < tool.Points[1][0] ? data[data.length - 1][0] : data[0][0];
            tool.Points[0][1] = tool.coef.A * x1 + tool.coef.B;
            tool.Points[1][1] = tool.coef.A * x2 + tool.coef.B;
            tool.Points[0][0] = tool.Points[0][0] < tool.Points[1][0] ? data[0][2] : data[data.length - 1][2];
            tool.Points[1][0] = tool.Points[0][0] < tool.Points[1][0] ? data[data.length - 1][2] : data[0][2];
            this.UpdateScreenPoints(ww);
        }
    }
    Draw(gr, ww, param) {
        const tool = this.dataCacheTool;
        if (tool) {
            if (tool.needRecalculate) {
                this.CalculateCoefficients(ww, param);
                this.FireUpdate();
            }
            if (tool.coef) {
                const coordinates = new Array(6);
                const cashItemSeriesSettings = param.mainPriceRenderer.Series.settings;
                if (cashItemSeriesSettings) {
                    coordinates[0] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[0][1] + tool.coef.Sigma * tool.UpperDeviation))));
                    coordinates[1] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[1][1] + tool.coef.Sigma * tool.UpperDeviation))));
                    coordinates[2] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[0][1]))));
                    coordinates[3] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[1][1]))));
                    coordinates[4] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[0][1] + tool.coef.Sigma * tool.LowerDeviation))));
                    coordinates[5] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(tool.Points[1][1] + tool.coef.Sigma * tool.LowerDeviation))));
                }
                else {
                    coordinates[0] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[0][1] + tool.coef.Sigma * tool.UpperDeviation)));
                    coordinates[1] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[1][1] + tool.coef.Sigma * tool.UpperDeviation)));
                    coordinates[2] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[0][1])));
                    coordinates[3] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[1][1])));
                    coordinates[4] = new Point(this.screenPoints[0][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[0][1] + tool.coef.Sigma * tool.LowerDeviation)));
                    coordinates[5] = new Point(this.screenPoints[1][0], Math.round(ww.PointsConverter.GetScreenY(tool.Points[1][1] + tool.coef.Sigma * tool.LowerDeviation)));
                }
                gr.DrawLine(tool.Pen, coordinates[2].X, coordinates[2].Y, coordinates[3].X, coordinates[3].Y);
                gr.DrawLine(tool.UpLinePen, coordinates[0].X, coordinates[0].Y, coordinates[1].X, coordinates[1].Y);
                gr.DrawLine(tool.DownLinePen, coordinates[4].X, coordinates[4].Y, coordinates[5].X, coordinates[5].Y);
                gr.FillPolygon(tool.UpBrush, [coordinates[0], coordinates[1], coordinates[3], coordinates[2]]);
                gr.FillPolygon(tool.DownBrush, [coordinates[2], coordinates[3], coordinates[5], coordinates[4]]);
            }
        }
        gr.DrawLine(tool.Pen, this.screenPoints[0][0], this.screenPoints[0][1], this.screenPoints[1][0], this.screenPoints[1][1]);
        super.Draw(gr, ww, param);
    }
    OnFinishCreationTool(e) {
        this.dataCacheTool.needRecalculate = true;
        super.OnFinishCreationTool(e);
    }
    ProcessMoveFinish() {
        super.ProcessMoveFinish();
        this.dataCacheTool.needRecalculate = true;
    }
}
